import { getLabelMessage } from '@gef-ui/localization/messages';
import ArrowLeft from '@gef-ui/material-icons/ArrowLeft';
import chainHandlersAsync from "@gef-ui/utils/chainHandlersAsync";
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React from 'react';
import { useModalState } from '../../../hooks/useDialogState';
import GenericDialog from '../GenericDialog';
const ConfirmDialog = ({ onCancel, onOk, onBack, title = getLabelMessage('confirm:title'), cancelLabel = getLabelMessage('confirm:cancel'), okLabel = getLabelMessage('confirm:continue'), backLabel = getLabelMessage('common:back'), onExit, withBackButton, ...other })=>/*#__PURE__*/ React.createElement(GenericDialog, {
        title: title,
        actions: /*#__PURE__*/ React.createElement(React.Fragment, null, withBackButton && /*#__PURE__*/ React.createElement(Button, {
            startIcon: /*#__PURE__*/ React.createElement(ArrowLeft, null),
            onClick: chainHandlersAsync([
                onBack,
                onExit
            ]),
            sx: {
                marginRight: 'auto',
                color: 'secondary.main'
            }
        }, backLabel), /*#__PURE__*/ React.createElement(Button, {
            onClick: chainHandlersAsync([
                onCancel,
                onExit
            ])
        }, cancelLabel), /*#__PURE__*/ React.createElement(Button, {
            onClick: chainHandlersAsync([
                onOk,
                onExit
            ]),
            variant: "contained",
            autoFocus: true
        }, okLabel)),
        onExit: onExit,
        ...other
    });
ConfirmDialog.propTypes = {
    backLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    okLabel: PropTypes.string,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onExit: PropTypes.func,
    onOk: PropTypes.func,
    title: PropTypes.node,
    withBackButton: PropTypes.bool
};
export const useLocalConfirmDialog = ({ onExit, ...others } = {})=>{
    const [isOpen, close, open] = useModalState();
    const dialog = /*#__PURE__*/ React.createElement(ConfirmDialog, {
        open: isOpen,
        onExit: chainHandlersAsync([
            onExit,
            close
        ]),
        ...others
    });
    return [
        dialog,
        open,
        close
    ];
};
export default ConfirmDialog;
